import React, { useState } from "react";
import { ClipboardDocumentIcon, CheckIcon } from "@heroicons/react/24/outline";
import { copyPhone } from "./phone";

export default function CopyPhone({ phone }) {
  const [copied, setCopied] = useState(false);
  if (!phone) return <span className="text-gray-500">Not provided</span>;
  return (
    <span className="inline-flex items-center gap-2">
      <span className="font-medium text-gray-900">{phone}</span>
      <button
        type="button"
        title="Copy phone number"
        onClick={async () => {
          const ok = await copyPhone(phone);
          if (!ok) return;
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        }}
        className="rounded-full p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900"
      >
        {copied ? <CheckIcon className="h-4 w-4 text-green-600" /> : <ClipboardDocumentIcon className="h-4 w-4" />}
      </button>
    </span>
  );
}
